import { render, staticRenderFns } from "./webStated.vue?vue&type=template&id=3359b757&scoped=true&"
import script from "./webStated.vue?vue&type=script&lang=js&"
export * from "./webStated.vue?vue&type=script&lang=js&"
import style0 from "./webStated.vue?vue&type=style&index=0&id=3359b757&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359b757",
  null
  
)

export default component.exports